module.exports = __webpack_public_path__ + "img/form_scheme_1.9e730678.png";